import type React from 'react';
import { useSelector } from 'react-redux';
import { sendGALinkClickEvent } from '@noths/polaris-client-google-analytics';

import { adaptDeliveryToSummary } from 'src/adapters/storeToUI/adaptDeliveryToSummary';
import { DELIVERY_DRAWER_URL_FRAGMENT_ID } from 'src/fragmentIDs';
import { selectDeliveryZones, selectSelectedZoneCode } from 'src/redux/delivery/selectors';
import { selectProductPartner } from 'src/redux/product/selectors';
import type { ReduxApplicationState } from 'src/redux/types';
import type { DeliverySummaryProps } from './DeliverySummary';

export const useDeliverySummary = (): DeliverySummaryProps => {
  const selectedDeliveryZone = useSelector((state: ReduxApplicationState) => {
    const allDeliveryZones = selectDeliveryZones(state);
    const selectedZoneCode = selectSelectedZoneCode(state);

    return (allDeliveryZones || []).find((zone) => zone.zoneCode === selectedZoneCode);
  });
  const deliveryEvent = useSelector((state: ReduxApplicationState) => state.delivery.deliveryEvent);
  const partner = useSelector(selectProductPartner);

  const { content, deliveryEventName, freePartnerDelivery } = adaptDeliveryToSummary({
    deliveryEvent,
    partnerName: partner?.name,
    selectedDeliveryZone,
  });

  return {
    content,
    deliveryEventName,
    freePartnerDelivery,
    href: `#${DELIVERY_DRAWER_URL_FRAGMENT_ID}`,
    onLinkClick: (event: React.MouseEvent<HTMLAnchorElement>) => {
      sendGALinkClickEvent(event, {
        event: 'custom_event_v2',
        event_name: 'select_content',
        event_details: 'link click',
        content_type: 'delivery information',
        item_id: 'delivery and returns details',
      });
    },
  };
};
